import React, { Component } from 'react';
import { Loading } from '../common/LoadingComponent';
import { Fade, Stagger } from 'react-animation-components';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Plane, Car, Train, Bus, Package, MapPin, Flag, ArrowDown, Route, Plus } from '../../icons';

const TRANSPORT_ICONS = { Avion: Plane, Voiture: Car, Train: Train, Bus: Bus };

function parseCities(raw) {
    if (!raw) return [];
    return raw.split('--').filter(Boolean);
}

function TripCard({ trip }) {
    const departureCities = parseCities(trip.departure);
    const destCities      = parseCities(trip.destination);
    const TransIcon       = TRANSPORT_ICONS[trip.meansOfTransport] || Package;
    const dateStr         = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: '2-digit', month: 'short' })
        .format(trip.dateDeparture);

    return (
        <Link to={`/mytrips/${trip.id}`} className="trip-card">
            <div className="trip-card__inner">
                <div className="trip-card__top">
                    <span className="trip-card__date">
                        <TransIcon size={14} strokeWidth={2} style={{ verticalAlign: 'middle', marginRight: 5 }} />
                        {dateStr}
                    </span>
                    <span className="trip-card__price">{trip.price} €</span>
                </div>
                <div className="trip-card__route">
                    <div className="trip-card__from">
                        <MapPin size={14} strokeWidth={2} color="var(--primary)" style={{ verticalAlign: 'middle', marginRight: 6 }} />
                        {departureCities[0] || '—'}
                    </div>
                    {destCities.slice(0, destCities.length - 1).map((city, i) => (
                        <div key={i} className="trip-card__stop">
                            <ArrowDown size={12} strokeWidth={2} color="var(--gray-light)" style={{ verticalAlign: 'middle', marginRight: 6 }} />
                            {city}
                        </div>
                    ))}
                    <div className="trip-card__to">
                        <Flag size={14} strokeWidth={2} color="var(--gray)" style={{ verticalAlign: 'middle', marginRight: 6 }} />
                        {destCities[destCities.length - 1] || '—'}
                    </div>
                </div>
            </div>
        </Link>
    );
}

class MyTrips extends Component {
    render() {
        const { myTrips } = this.props;

        if (myTrips.isLoadingTrips) return <div className="container text-center" style={{ padding: '80px 0' }}><Loading /></div>;
        if (myTrips.errMess)        return <div className="container text-center" style={{ padding: '80px 0' }}><p style={{ color: 'var(--gray)' }}>{myTrips.errMess}</p></div>;

        if (!Array.isArray(myTrips.myTrips) || !myTrips.myTrips.length) {
            return (
                <div className="list-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-6">
                                <div className="empty-state">
                                    <div className="empty-state__icon"><Route size={48} strokeWidth={1.2} color="var(--border)" /></div>
                                    <h3 className="empty-state__title">Vous n'avez pas encore de trajet</h3>
                                    <p className="empty-state__text">Vous voyagez prochainement ? Publiez votre trajet et rentabilisez vos bagages.</p>
                                    <Link to="/addtrip">
                                        <Button color="primary" style={{ borderRadius: 50, padding: '13px 28px', fontWeight: 700 }}>
                                            Ajouter un trajet
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="list-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-7 col-lg-6">
                            <div className="list-page__header">
                                <h1 className="list-page__title">Mes trajets</h1>
                                <Link to="/addtrip">
                                    <Button color="primary" size="sm" style={{ borderRadius: 50, fontWeight: 700, padding: '8px 18px', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                        <Plus size={15} strokeWidth={2.5} /> Ajouter
                                    </Button>
                                </Link>
                            </div>
                            <Stagger in>
                                {myTrips.myTrips.map(trip => (
                                    <Fade in key={trip.id}><TripCard trip={trip} /></Fade>
                                ))}
                            </Stagger>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MyTrips;
